import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=19e706ca&scoped=true&"
import script from "./menu.vue?vue&type=script&lang=ts&"
export * from "./menu.vue?vue&type=script&lang=ts&"
import style0 from "./menu.vue?vue&type=style&index=0&id=19e706ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e706ca",
  null
  
)

export default component.exports